import { ExaminationRoom } from '@/pages/clinic/examinationRooms/columns'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse, PaginationResponse } from '@magnetar/admin-api-interfaces'

export function useExaminationRooms(inputParams: {
  page: number
  pageSize: number
  clinic_id?: number
  department?: string
}) {
  const { token } = useAuth()

  const params: Record<string, unknown> = {
    page: inputParams.page,
    pageSize: inputParams.pageSize,
  }

  if (inputParams.clinic_id) params.clinic_id = inputParams.clinic_id
  if (inputParams.department) params.department = inputParams.department

  const { data, error, mutate } = useGet<ApiResponse<PaginationResponse<ExaminationRoom>>>(
    token ? '/api/examination-rooms' : null,
    params,
    token ?? '',
    undefined,
    { keepPreviousData: true },
  )

  return {
    examinationRooms: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
